import React from 'react';
import { Heading2, Card, CTAButton, Stack } from '@ovotech/element-v4';
import {
  useAccountContext,
  useCustomerContext,
  AnalyticsClick,
} from '@ovotech/ui-tools';
import { HOME_MOVES_WANT_TO_TAKE_OVO } from '@/src/constants/analytics-subjects';
import { redirectToQS } from '../../utils/redirectToQS';

export const WantToTakeOvoWithYouCard = () => {
  const { accountId } = useAccountContext();
  const { customerId } = useCustomerContext();

  const handleGetQuoteClick = () => {
    redirectToQS(accountId, customerId);
  };

  return (
    <Card>
      <Stack spaceBetween={[4, 6, 6]}>
        <Heading2>Want to take OVO with you to your new home?</Heading2>

        <div>
          By clicking “Get a quote”, you agree that we can use your new address
          to find your meter details and current supplier via industry
          databases.
        </div>

        <AnalyticsClick
          name={HOME_MOVES_WANT_TO_TAKE_OVO}
          properties={{
            accountId,
            customerId,
          }}
        >
          <CTAButton onClick={handleGetQuoteClick}>Get a quote</CTAButton>
        </AnalyticsClick>
      </Stack>
    </Card>
  );
};
